import React from 'react';
import { useIntl } from 'react-intl';
import { ColumnFlexBox } from '../../../../Components/FlexBox';
import { Typography } from '@mui/material';
import CaptionValue from '../../../../Components/CaptionValue/CaptionValue';
import { formatThousands } from '../../../../Utils/constants/general';

const TooltipComponent = function TooltipComponent({ data, colorScale }) {
  const intl = useIntl();

  // eslint-disable-next-line no-unused-vars
  const { label, target, index, details, ...rest } = data?.data || {};
  return (
    <ColumnFlexBox gap="8px" padding="8px" minWidth="240px">
      {label && (
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            fontWeight: 'bold'
          }}>
          {label}
        </Typography>
      )}
      {Object.keys(rest).map((keyName) => (
        <>
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              fontWeight: data?.key === keyName ? 'bold' : 'lighter',
              color: colorScale(keyName)
            }}>
            {intl.messages[keyName?.toUpperCase()] || keyName}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              color: colorScale(keyName),
              fontWeight: data?.key === keyName ? 'bold' : 'lighter'
            }}>
            {formatThousands(rest[keyName] || 0)}
          </Typography>
        </>
      ))}
      {details?.map(({ name, callCount }) => (
        <CaptionValue
          key={name}
          direction="row"
          width="100%"
          caption={`${intl.messages.TIME} - ${name}`}
          value={formatThousands(callCount)}
          valueColor={colorScale('unansweredCallCount')}
          captionStyle={{ flexGrow: 1 }}
          valueStyle={{ fontWeight: 'bold' }}
          captionColor="#fff"
        />
      ))}
    </ColumnFlexBox>
  );
};

export default TooltipComponent;
